module.exports = __webpack_public_path__ + "img/ico_number_up.44f20192.svg";